import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Base64 } from 'js-base64';
import moment from 'moment';

function VehicleMaintenanceTable({maintenanceVehicle = []}) {

    console.log("maintenanceVehicle",maintenanceVehicle);
    const dateFormat = (date) => {
        // Handle ISO 8601 format with quotes
        const dateString = date.replace(/"/g, '');
        return moment.utc(dateString).format('MM/DD/YYYY');
    };

    return (
        <TableContainer sx={{ boxShadow: 'none' }}>
                <Table sx={{ border: '1px solid #31876f33' }}>
                  <TableHead className='table-header'>
                    <TableRow>
                      <TableCell style={{ border: '1px solid #d5d2d2', width: '50%', textAlign: 'left' }} sx={{ fontWeight: 'bold', padding: '5px',paddingLeft:'16px', color: '#fff !important' }}>Vehicle</TableCell>
                      <TableCell style={{ border: '1px solid #d5d2d2', width: '25%', textAlign: 'left' }} sx={{ fontWeight: 'bold', padding: '5px', color: '#fff !important' }}>Driver Name</TableCell>
                      <TableCell className='tbl-cell' style={{ border: '1px solid #d5d2d2', width: '25%', textAlign: 'left' }} sx={{ fontWeight: 'bold', padding: '5px' }}>Last Updated</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {maintenanceVehicle && maintenanceVehicle.length > 0 ? (
                      (maintenanceVehicle || []).map((vehicle, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ border: '1px solid #d5d2d2' ,padding:'0px',paddingLeft:'16px'}}>
                            <a
                              href={`/home/vehicle/report?vehicleName=${Base64.encode(vehicle.vehicle_name)}&vehicleId=${Base64.encode(vehicle.vehicle_id)}&activeMenu=vehicles`}
                              style={{ textDecoration: 'none', color: '#31876f' }}
                            >
                              {vehicle.vehicle_name} <br />
                               
                            </a>
                                                      {(() => {
                              const questions = vehicle.questions || [];
                              const limit = 100;
                              let charCount = 0;
                              const elements = [];

                              for (let i = 0; i <  Math.min(2, questions.length); i++) {
                                const q = questions[i];
                                const isLast = i === Math.min(2, questions.length) - 1;
                                
                                elements.push(
                                  <span key={i} style={{ display: 'inline-block', marginRight: '6px' }}>
                                    <span style={{ color: '#000',fontSize:'13px' }}>{q.question?.check_list || q.question}</span>
                                    <span style={{ color: 'red',fontSize:'13px' }}> - {q.status}</span>
                                   {!isLast && ','}
                                  </span>
                                );
                              }

                              return elements;
                            })()}
                          </TableCell>
                          <TableCell style={{ border: '1px solid #d5d2d2' }}>
                           
                             {vehicle?.driver_name}
                          </TableCell>
                          <TableCell className='maintenance-tbody-cell' style={{ border: '1px solid #d5d2d2' }}>
                            {dateFormat(vehicle.last_update_date)}</TableCell>
                        </TableRow>
                      ))
                    ) : null}

                    {/* Add empty rows to maintain 7 rows */}
                    {Array.from({ length: 5 - (maintenanceVehicle?.length || 0) }).map((_, index) => (
                      <TableRow key={`empty-${index}`}>
                        <TableCell style={{ border: '1px solid #d5d2d2', color: 'grey' }}>N/A</TableCell>
                        <TableCell style={{ border: '1px solid #d5d2d2', color: 'grey' }}>N/A</TableCell>
                        <TableCell className='maintenance-tbody-cell' style={{ color: 'grey' }}>N/A</TableCell>
                      </TableRow>
                    ))}
                    {/* Show Load More if there are more than 5 records */}
                    {maintenanceVehicle && maintenanceVehicle.length > 5 && (
                      <TableRow
                        style={{ cursor: 'pointer', backgroundColor: '#f1f1f1' }}
                        onClick={() => window.location.href = '/home/vehicle/list'}
                      >
                        <TableCell colSpan={3} align="right" style={{ border: '1px solid #d5d2d2', color: '#31876f', fontWeight: 'bold' }}>
                          View More...
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
    );
}

export default VehicleMaintenanceTable;

